import React from "react";
import { Link } from "../../utils/customLink";
import Image from "../../components/image";

import ArrowRight from "../../images/icons/arrow-right.inline.svg";

const HomeCard = ({
  isMobile = false,
  sidebarTitle,
  sidebarContent,
  sidebarOverlayImage,
  sidebarBackgroundImage,
  peopleDomain
}) => {
  return (
    <>
      <div
        className={`max-w-sm w-full relative ${
          isMobile ? "block sm:hidden" : ""
        } sm:w-[355px]`}
      >
        <Link to={peopleDomain}>
          <div className="relative transition duration-500 sm:shadow-lg hover:shadow-xl sm:border-gray-testimonial rounded-xs sm:rounded-xs border-0.5 py-6 px-6">
            <div className="absolute flex items-center pt-4">
              <span className="text-black-lighter dark:text-white pr-2 uppercase font-semibold text-xs menu-link tracking-[0.19em]">
                People
              </span>
              <ArrowRight className="w-3 h-3 stroke-red-light gvi-text-green" />
            </div>

            <div className="absolute flex pt-12 z-20">
              <h1
                className="flex flex-col text-[38px] leading-[38px] font-normal text-white !font-alice"
                dangerouslySetInnerHTML={{ __html: sidebarTitle }}
              />
            </div>

            <div className="flex right-0 top-0 justify-end items-end">
              <div
                className="w-24 h-24 md:w-48 md:h-48 rounded-xs sm:rounded-br-none sm:rounded-bl-none bg-black-lighter relative"
                style={{
                  backgroundImage: `url(${sidebarBackgroundImage?.sourceUrl})`
                }}
              >
                <Image
                  imageAlt={""}
                  image={sidebarOverlayImage?.gatsbyImage}
                  imageClass="flex w-24 h-24 md:w-48 md:h-48 bg-contain bg-no-repeat bg-center mt-4 -ml-4 sm:mt-8 sm:-ml-8"
                  sourceUrl={sidebarOverlayImage?.sourceUrl}
                />
              </div>
            </div>

            <div className="flex bg-transparent pt-16 pb-6">
              <div
                className="text-base text-gray-generic leading-[25px] pt-6 md:pt-0"
                dangerouslySetInnerHTML={{ __html: sidebarContent }}
              />
            </div>

            <div className="flex w-full sm:w-8/12 py-2 sm:flex max-w-sm font-bold text-white items-center justify-center text-base gap-2 border border-solid rounded-full px-6">
              <div className="col-span-1">Visit GVI People</div>
              <div className="col-span-1">
                <ArrowRight className="stroke-white" />
              </div>
            </div>
          </div>
        </Link>
      </div>
    </>
  );
};

export default HomeCard;
